module.exports = __webpack_public_path__ + "static/media/Slide2.e9e519da.jpeg";